import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Pagination from "../../common/Pagination";

/**
 * Pagination controls for the sales page.
 *
 * Callback props are guarded to prevent runtime errors caused by missing or
 * incorrectly configured callbacks.
 */
const SalesPaginationBar = ({
  disabled,
  onPageChange,
  onPageSizeChange,
  page,
  pageSize,
  totalCount,
}) => {
  const handleChange = typeof onPageSizeChange === "function"
    ? (e) => onPageSizeChange(Number(e.target.value))
    : undefined;

  const handlePageChange = typeof onPageChange === "function"
    ? (_, p) => onPageChange(p)
    : undefined;

  return (
    <Grid
      container
      spacing={0}
      sx={{
        mb: -1,
        minHeight: (theme) => theme.spacing(2),
      }}
    >
      <Grid item sx={{
        display: "flex",
        flex: 1,
        flexFlow: "row wrap",
        gap: "10px",
        justifyContent: "flex-end",
      }}>
        <Pagination
          disabled={disabled}
          hideIfEmpty
          onChange={handleChange}
          onPageChange={handlePageChange}
          page={page}
          perPage={pageSize}
          totalCount={totalCount}
        />
      </Grid>
    </Grid>
  );
};

SalesPaginationBar.defaultProps = {
  disabled: false,
};

SalesPaginationBar.propTypes = {
  disabled: PropTypes.bool,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
};

SalesPaginationBar.displayName = "SalesPaginationBar";

export default SalesPaginationBar;
